"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SeeAllBanner = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'flex-end',
  background: 'linear-gradient(0deg, rgb(255, 255, 255) 0%, rgba(255,255,255,0.7) 65%, rgba(255,255,255,0) 100%)',
  bottom: theme.spacing(-1),
  display: 'flex',
  height: 110,
  justifyContent: 'center',
  left: 0,
  paddingBottom: theme.spacing(2),
  position: 'absolute',
  right: 0
}));
const Text = (0, _mui.styled)(_mui.Typography)(() => ({
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex'
}));
const Icon = (0, _mui.styled)(_components.IconButton)(({
  theme
}) => ({
  fontSize: '3.6rem',
  height: 30,
  marginLeft: theme.spacing(1),
  width: 30
}));
const SeeAllBanner = ({
  count,
  onClick
}) => {
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const text = formatMessage('seeAllItems', {
    0: count
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Root, {
    onClick: onClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Text, {
      children: [text, ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
        variant: "text",
        color: "default",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowDownThin, {
          fontSize: "large"
        })
      })]
    })
  });
};
exports.SeeAllBanner = SeeAllBanner;